import { render, staticRenderFns } from "./customerInformation.vue?vue&type=template&id=98e0d4c6&scoped=true"
import script from "./customerInformation.vue?vue&type=script&lang=js"
export * from "./customerInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e0d4c6",
  null
  
)

export default component.exports